var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "upload-single-image d-flex flex-column h-100" },
    [
      _vm.label
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c("h6", { staticClass: "font-weight-normal" }, [
                _vm._v(_vm._s(_vm.label)),
              ]),
              _vm._v(" "),
              _c("hr", { staticClass: "mt-2" }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row h-100" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "h-100" },
            [
              _c("UploadMultipleImage", {
                ref: _vm.name,
                attrs: {
                  disabled: _vm.disabled,
                  maxImage: 1,
                  multiple: false,
                  noOverlay: true,
                  name: _vm.name,
                  showImageLimitMessage: false,
                  imageClass: _vm.imageClass,
                },
                model: {
                  value: _vm.images,
                  callback: function ($$v) {
                    _vm.images = $$v
                  },
                  expression: "images",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }